import React from "react";
import {useSelector} from "react-redux";
import {useFormState} from "react-final-form";

function useApplyFieldStatus(name) {
    const formState = useFormState();
    const fieldData = useSelector(state => state.applyField[name]);

    const checkStatus = status => {
        return fieldData && fieldData.value === formState.values[name] && fieldData.status === status;
    }

    return {
        checkStatus: checkStatus
    }
}

export default useApplyFieldStatus;